export default __webpack_public_path__ + "static/media/powered-by-algebra.bd4483ff.svg";